import {FC} from 'react'
import {PaymentExpertForm} from './components/PaymentExpertForm'

const PaymentExpertPage: FC = () => {
  return <PaymentExpertForm />
}

export {PaymentExpertPage}
